import { render } from "./HistorialCxc.vue?vue&type=template&id=55c16aaa&scoped=true"
import script from "./HistorialCxc.vue?vue&type=script&lang=js"
export * from "./HistorialCxc.vue?vue&type=script&lang=js"

import "./HistorialCxc.vue?vue&type=style&index=0&id=55c16aaa&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Public\\frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c16aaa"]])

export default __exports__